import '../../../../../../d3-color/src/color.js';
import '../../../../../../d3-color/src/lab.js';
import cubehelix from '../../../../../../d3-color/src/cubehelix.js';
import '../../../d3-interpolate/src/rgb.js';
import '../../../d3-interpolate/src/zoom.js';
import { cubehelixLong } from '../../../d3-interpolate/src/cubehelix.js';
cubehelixLong(cubehelix(-100, 0.75, 0.35), cubehelix(80, 1.50, 0.8));
cubehelixLong(cubehelix(260, 0.75, 0.35), cubehelix(80, 1.50, 0.8));
cubehelix();
//# sourceMappingURL=rainbow.js.map
